import { PropType } from "vue";
import { HalfDateProps } from "./type";

export default {
  modelValue: [Array] as PropType<HalfDateProps["modelValue"]>,
};
